import * as React from 'react';
import { clsx } from 'clsx';
import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './FavoriteButton.css';

type TFavoriteButtonProps = {
  isActive: boolean;
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
};

export const FavoriteButton: React.FC<TFavoriteButtonProps> = ({ isActive, onClick }) => (
  <button
    type="button"
    className={clsx(styles['favorite-button'], isActive && styles['active'])}
    title="Избранное"
    aria-label="Избранное"
    aria-pressed={isActive}
    onClick={onClick}
  >
    {isActive ? (
      <IconToggleHeartOn16 color="icon-negative-default" aria-label="heartActive" display="block" />
    ) : (
      <IconToggleHeartOff16 color="icon-secondary-default" aria-label="heart" display="block" />
    )}
  </button>
);
